import axios from 'axios';
import config from '../../../config';

const { apiServerUrl, ruleServerUrl } = config;

export const getPosLanding = (businessId: number) =>
  axios
    .get(`${apiServerUrl}/users/pos`, {
      headers: {
        'business-id': businessId.toString(),
      },
    })
    .then(({ data }) => data);

export const savePosDetails = (
  businessId: number,
  payload: Record<string, unknown>
) =>
  axios
    .post(`${apiServerUrl}/users/pos`, payload, {
      headers: {
        'business-id': businessId.toString(),
      },
    })
    .then(({ data }) => data);

export const updatePosDetails = (
  businessId: number,
  payload: Record<string, unknown>
) =>
  axios
    .put(`${apiServerUrl}/users/pos`, payload, {
      headers: {
        'business-id': businessId.toString(),
      },
    })
    .then(({ data }) => data);

export const getCustomerDetails = (
  mobile: string,
  businessId: number,
  businessName: string
) =>
  axios
    .get(`${ruleServerUrl}/users/customer-details`, {
      params: { mobile, bu: businessId, isCustomerInfoOnly: false },
      headers: {
        'business-id': businessId.toString(),
        'business-name': businessName,
      },
    })
    .then(({ data }) => data);
